@file:OptIn(InternalResourceApi::class)

package gloopgo.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.ScriptQualifier
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gloopgo.shared.generated.resources/"

@delegate:ResourceContentHash(941_481_476)
internal val Res.string.privacy_card_desc: StringResource by lazy {
      StringResource("string:privacy_card_desc", "privacy_card_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6547, 177),
      ))
    }

@delegate:ResourceContentHash(985_769_822)
internal val Res.string.privacy_card_title: StringResource by lazy {
      StringResource("string:privacy_card_title", "privacy_card_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6725, 38),
      ))
    }

@delegate:ResourceContentHash(1_726_291_323)
internal val Res.string.privacy_hosted_url_hint: StringResource by lazy {
      StringResource("string:privacy_hosted_url_hint", "privacy_hosted_url_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6764, 99),
      ))
    }

@delegate:ResourceContentHash(560_833_065)
internal val Res.string.privacy_notice_title: StringResource by lazy {
      StringResource("string:privacy_notice_title", "privacy_notice_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6864, 48),
      ))
    }

@delegate:ResourceContentHash(1_668_973_487)
internal val Res.string.privacy_open_button: StringResource by lazy {
      StringResource("string:privacy_open_button", "privacy_open_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6913, 55),
      ))
    }

@delegate:ResourceContentHash(-821_147_311)
internal val Res.string.privacy_operator_callout: StringResource by lazy {
      StringResource("string:privacy_operator_callout", "privacy_operator_callout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6969, 372),
      ))
    }

@delegate:ResourceContentHash(2_035_438_045)
internal val Res.string.safety_block: StringResource by lazy {
      StringResource("string:safety_block", "safety_block", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4509, 36),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4513, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4745, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4833, 44),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5505, 60),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5057, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4509, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7465, 36),
      ))
    }

@delegate:ResourceContentHash(364_907_313)
internal val Res.string.safety_blocked_confirm: StringResource by lazy {
      StringResource("string:safety_blocked_confirm", "safety_blocked_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4386, 122),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4390, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4626, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4702, 130),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5294, 210),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4894, 162),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4386, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7342, 122),
      ))
    }

@delegate:ResourceContentHash(1_900_858_511)
internal val Res.string.safety_close: StringResource by lazy {
      StringResource("string:safety_close", "safety_close", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4546, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4550, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4790, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4878, 28),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5566, 32),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5106, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4546, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7502, 28),
      ))
    }

@delegate:ResourceContentHash(-1_725_537_485)
internal val Res.string.safety_reason_cheating: StringResource by lazy {
      StringResource("string:safety_reason_cheating", "safety_reason_cheating", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4575, 38),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4579, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4819, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4907, 38),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5599, 46),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5135, 46),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4575, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7531, 42),
      ))
    }

@delegate:ResourceContentHash(1_292_447_593)
internal val Res.string.safety_reason_offensive: StringResource by lazy {
      StringResource("string:safety_reason_offensive", "safety_reason_offensive", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4614, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4618, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4862, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4946, 51),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5646, 55),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5182, 55),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4614, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7574, 51),
      ))
    }

@delegate:ResourceContentHash(-54_746_392)
internal val Res.string.safety_reason_other: StringResource by lazy {
      StringResource("string:safety_reason_other", "safety_reason_other", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4666, 35),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4670, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4914, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4998, 35),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5702, 39),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5238, 35),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4666, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7626, 35),
      ))
    }

@delegate:ResourceContentHash(44_939_546)
internal val Res.string.safety_reason_prompt: StringResource by lazy {
      StringResource("string:safety_reason_prompt", "safety_reason_prompt", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4702, 72),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4706, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4950, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5034, 76),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5742, 92),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5274, 108),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4702, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7662, 76),
      ))
    }

@delegate:ResourceContentHash(-1_218_365_283)
internal val Res.string.safety_report: StringResource by lazy {
      StringResource("string:safety_report", "safety_report", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4889, 37),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4893, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5173, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5249, 45),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6013, 53),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5541, 49),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4889, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7857, 41),
      ))
    }

@delegate:ResourceContentHash(-1_731_280_095)
internal val Res.string.safety_report_failed: StringResource by lazy {
      StringResource("string:safety_report_failed", "safety_report_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4775, 72),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4779, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5027, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5111, 92),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5835, 132),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5383, 116),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4775, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7739, 76),
      ))
    }

@delegate:ResourceContentHash(1_048_565_510)
internal val Res.string.safety_reporting: StringResource by lazy {
      StringResource("string:safety_reporting", "safety_reporting", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4848, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4852, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5124, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5204, 44),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5968, 44),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5500, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4848, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7816, 40),
      ))
    }

@delegate:ResourceContentHash(1_543_963_712)
internal val Res.string.safety_thanks: StringResource by lazy {
      StringResource("string:safety_thanks", "safety_thanks", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4927, 65),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4931, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5219, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5295, 81),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6067, 101),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5591, 73),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4927, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7899, 57),
      ))
    }

@delegate:ResourceContentHash(-2_081_477_874)
internal val Res.string.safety_title: StringResource by lazy {
      StringResource("string:safety_title", "safety_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4993, 36),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4997, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5273, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5377, 44),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6169, 52),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5665, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4993, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7957, 40),
      ))
    }

@delegate:ResourceContentHash(-353_175_507)
internal val Res.string.safety_unblock: StringResource by lazy {
      StringResource("string:safety_unblock", "safety_unblock", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5030, 38),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5034, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5322, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5422, 38),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6222, 46),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5714, 42),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5030, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7998, 34),
      ))
    }

@delegate:ResourceContentHash(-1_463_812_165)
internal val Res.string.settings: StringResource by lazy {
      StringResource("string:settings", "settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10192, 28),
      ))
    }

@delegate:ResourceContentHash(1_285_925_246)
internal val Res.string.settings_back_to_menu: StringResource by lazy {
      StringResource("string:settings_back_to_menu", "settings_back_to_menu", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5069, 45),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5073, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5361, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5461, 49),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6269, 57),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5757, 61),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5069, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8033, 45),
      ))
    }

@delegate:ResourceContentHash(2_131_888_421)
internal val Res.string.settings_controls_title: StringResource by lazy {
      StringResource("string:settings_controls_title", "settings_controls_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5179, 55),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5183, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5475, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5583, 63),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6415, 79),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5891, 63),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5179, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8151, 63),
      ))
    }

@delegate:ResourceContentHash(1_366_363_562)
internal val Res.string.settings_controls_title_compact: StringResource by lazy {
      StringResource("string:settings_controls_title_compact", "settings_controls_title_compact", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5115, 63),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5119, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5411, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5511, 71),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6327, 87),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5819, 71),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5115, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8079, 71),
      ))
    }

@delegate:ResourceContentHash(756_186_352)
internal val Res.string.settings_ctrl_eject: StringResource by lazy {
      StringResource("string:settings_ctrl_eject", "settings_ctrl_eject", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5235, 79),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5239, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5531, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5647, 107),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6495, 103),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 5955, 95),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5235, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8215, 83),
      ))
    }

@delegate:ResourceContentHash(1_592_257_840)
internal val Res.string.settings_ctrl_leave: StringResource by lazy {
      StringResource("string:settings_ctrl_leave", "settings_ctrl_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5315, 87),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5319, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5623, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5755, 103),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6599, 95),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 6051, 95),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5315, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8299, 83),
      ))
    }

@delegate:ResourceContentHash(-1_127_007_527)
internal val Res.string.settings_ctrl_pause: StringResource by lazy {
      StringResource("string:settings_ctrl_pause", "settings_ctrl_pause", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5403, 111),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5407, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5719, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5859, 111),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6695, 159),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 6147, 131),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5403, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8383, 111),
      ))
    }

@delegate:ResourceContentHash(-25_783_430)
internal val Res.string.settings_ctrl_split: StringResource by lazy {
      StringResource("string:settings_ctrl_split", "settings_ctrl_split", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5515, 87),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5519, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5831, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5971, 99),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6855, 111),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 6279, 107),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5515, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8495, 87),
      ))
    }

@delegate:ResourceContentHash(660_155_989)
internal val Res.string.settings_ctrl_steer_joystick: StringResource by lazy {
      StringResource("string:settings_ctrl_steer_joystick", "settings_ctrl_steer_joystick", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5603, 116),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5607, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5927, 144),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6071, 140),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 6967, 152),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 6387, 136),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5603, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8583, 120),
      ))
    }

@delegate:ResourceContentHash(-624_195_890)
internal val Res.string.settings_ctrl_steer_pointer: StringResource by lazy {
      StringResource("string:settings_ctrl_steer_pointer", "settings_ctrl_steer_pointer", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5720, 111),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5724, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6072, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6212, 135),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 7120, 139),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 6524, 119),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5720, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8704, 107),
      ))
    }

@delegate:ResourceContentHash(-1_040_664_415)
internal val Res.string.settings_ctrl_toggle_joystick: StringResource by lazy {
      StringResource("string:settings_ctrl_toggle_joystick", "settings_ctrl_toggle_joystick", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5832, 129),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5836, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6196, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6348, 149),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 7260, 169),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 6644, 149),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5832, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8812, 137),
      ))
    }

@delegate:ResourceContentHash(90_986_384)
internal val Res.string.settings_ctrl_zoom: StringResource by lazy {
      StringResource("string:settings_ctrl_zoom", "settings_ctrl_zoom", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 5962, 98),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 5966, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6342, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6498, 110),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 7430, 110),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 6794, 102),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5962, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8950, 94),
      ))
    }

@delegate:ResourceContentHash(-521_332_969)
internal val Res.string.settings_desc: StringResource by lazy {
      StringResource("string:settings_desc", "settings_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9045, 57),
      ))
    }

@delegate:ResourceContentHash(373_758_135)
internal val Res.string.settings_joystick_mode_active: StringResource by lazy {
      StringResource("string:settings_joystick_mode_active", "settings_joystick_mode_active", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6061, 77),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6065, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6449, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6609, 73),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 7541, 101),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 6897, 85),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6061, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9103, 77),
      ))
    }

@delegate:ResourceContentHash(1_432_572_960)
internal val Res.string.settings_joystick_mode_desc: StringResource by lazy {
      StringResource("string:settings_joystick_mode_desc", "settings_joystick_mode_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6139, 159),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6143, 159),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6527, 219),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6683, 203),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 7643, 207),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 6983, 235),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6139, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9181, 187),
      ))
    }

@delegate:ResourceContentHash(-1_725_753_090)
internal val Res.string.settings_pointer_mode_active: StringResource by lazy {
      StringResource("string:settings_pointer_mode_active", "settings_pointer_mode_active", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6299, 72),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6303, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6747, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6887, 68),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 7851, 80),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 7219, 76),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6299, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9369, 68),
      ))
    }

@delegate:ResourceContentHash(399_248_787)
internal val Res.string.settings_pointer_mode_desc: StringResource by lazy {
      StringResource("string:settings_pointer_mode_desc", "settings_pointer_mode_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6372, 166),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6376, 166),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6816, 190),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6956, 202),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 7932, 234),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 7296, 222),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6372, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9438, 182),
      ))
    }

@delegate:ResourceContentHash(1_347_282_644)
internal val Res.string.settings_preferences: StringResource by lazy {
      StringResource("string:settings_preferences", "settings_preferences", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6539, 44),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6543, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7007, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7159, 48),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8167, 44),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 7519, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6539, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9621, 44),
      ))
    }

@delegate:ResourceContentHash(363_641_990)
internal val Res.string.settings_sound_effects: StringResource by lazy {
      StringResource("string:settings_sound_effects", "settings_sound_effects", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6688, 38),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6692, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7176, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7336, 50),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8360, 42),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 7684, 42),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6688, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9794, 50),
      ))
    }

@delegate:ResourceContentHash(1_765_296_382)
internal val Res.string.settings_sound_effects_desc: StringResource by lazy {
      StringResource("string:settings_sound_effects_desc", "settings_sound_effects_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6584, 103),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6588, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7052, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7208, 127),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8212, 147),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 7568, 115),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6584, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9666, 127),
      ))
    }

@delegate:ResourceContentHash(-1_130_048_893)
internal val Res.string.settings_subtitle: StringResource by lazy {
      StringResource("string:settings_subtitle", "settings_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6727, 89),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6731, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7231, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7387, 113),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8403, 105),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 7727, 105),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6727, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9845, 97),
      ))
    }

@delegate:ResourceContentHash(1_768_794_486)
internal val Res.string.settings_title: StringResource by lazy {
      StringResource("string:settings_title", "settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6817, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6817, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7337, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7501, 38),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8509, 30),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 7833, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6817, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9943, 34),
      ))
    }

@delegate:ResourceContentHash(-992_935_502)
internal val Res.string.settings_use_joystick: StringResource by lazy {
      StringResource("string:settings_use_joystick", "settings_use_joystick", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6963, 53),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6963, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7507, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7667, 57),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8687, 73),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 7999, 57),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6963, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10101, 45),
      ))
    }

@delegate:ResourceContentHash(-1_827_612_234)
internal val Res.string.settings_use_joystick_desc: StringResource by lazy {
      StringResource("string:settings_use_joystick_desc", "settings_use_joystick_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 6848, 114),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 6848, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7372, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7540, 126),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8540, 146),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 7864, 134),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6848, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9978, 122),
      ))
    }

@delegate:ResourceContentHash(1_076_793_344)
internal val Res.string.settings_version: StringResource by lazy {
      StringResource("string:settings_version", "settings_version", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7017, 44),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7017, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7557, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7725, 44),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8761, 44),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8057, 44),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7017, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10147, 44),
      ))
    }

@delegate:ResourceContentHash(1_474_780_995)
internal val Res.string.single_player: StringResource by lazy {
      StringResource("string:single_player", "single_player", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10268, 41),
      ))
    }

@delegate:ResourceContentHash(-1_583_092_280)
internal val Res.string.single_player_desc: StringResource by lazy {
      StringResource("string:single_player_desc", "single_player_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7062, 62),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7062, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7602, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7770, 46),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8806, 58),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8102, 62),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7062, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10221, 46),
      ))
    }

@delegate:ResourceContentHash(-1_328_536_970)
internal val Res.string.skin_bat: StringResource by lazy {
      StringResource("string:skin_bat", "skin_bat", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7125, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7125, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7649, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7817, 36),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8865, 32),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8165, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7125, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10310, 20),
      ))
    }

@delegate:ResourceContentHash(1_816_008_888)
internal val Res.string.skin_bear: StringResource by lazy {
      StringResource("string:skin_bear", "skin_bear", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7150, 25),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7150, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7682, 21),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7854, 25),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8898, 25),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8190, 21),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7150, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10331, 25),
      ))
    }

@delegate:ResourceContentHash(-1_134_807_877)
internal val Res.string.skin_bee: StringResource by lazy {
      StringResource("string:skin_bee", "skin_bee", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7176, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7176, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7704, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7880, 28),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8924, 24),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8212, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7176, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10357, 20),
      ))
    }

@delegate:ResourceContentHash(-459_801_613)
internal val Res.string.skin_bunny: StringResource by lazy {
      StringResource("string:skin_bunny", "skin_bunny", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7201, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7201, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7729, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7909, 26),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8949, 30),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8237, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7201, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10378, 26),
      ))
    }

@delegate:ResourceContentHash(-592_451_715)
internal val Res.string.skin_butterfly: StringResource by lazy {
      StringResource("string:skin_butterfly", "skin_butterfly", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7228, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7228, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7760, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7936, 34),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 8980, 34),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8264, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7228, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10405, 34),
      ))
    }

@delegate:ResourceContentHash(-1_292_441_143)
internal val Res.string.skin_cat: StringResource by lazy {
      StringResource("string:skin_cat", "skin_cat", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7259, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7259, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7795, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7971, 24),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9015, 24),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8295, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7259, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10440, 20),
      ))
    }

@delegate:ResourceContentHash(-1_993_429_973)
internal val Res.string.skin_chick: StringResource by lazy {
      StringResource("string:skin_chick", "skin_chick", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7284, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7284, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7820, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7996, 30),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9040, 30),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8324, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7284, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10461, 26),
      ))
    }

@delegate:ResourceContentHash(-272_344_153)
internal val Res.string.skin_cow: StringResource by lazy {
      StringResource("string:skin_cow", "skin_cow", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7311, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7311, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7851, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8027, 24),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9071, 24),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8355, 20),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7311, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10488, 20),
      ))
    }

@delegate:ResourceContentHash(-451_153_592)
internal val Res.string.skin_crab: StringResource by lazy {
      StringResource("string:skin_crab", "skin_crab", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7336, 25),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7336, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7876, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8052, 25),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9096, 25),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8376, 21),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7336, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10509, 25),
      ))
    }

@delegate:ResourceContentHash(1_780_491_805)
internal val Res.string.skin_crocodile: StringResource by lazy {
      StringResource("string:skin_crocodile", "skin_crocodile", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7362, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7362, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7906, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8078, 34),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9122, 30),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8398, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7362, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10535, 34),
      ))
    }

@delegate:ResourceContentHash(2_015_285_915)
internal val Res.string.skin_dog: StringResource by lazy {
      StringResource("string:skin_dog", "skin_dog", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7393, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7393, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7941, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8113, 24),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9153, 24),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8429, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7393, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10570, 20),
      ))
    }

@delegate:ResourceContentHash(342_673_599)
internal val Res.string.skin_dolphin: StringResource by lazy {
      StringResource("string:skin_dolphin", "skin_dolphin", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7418, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7418, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7966, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8138, 32),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9178, 32),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8458, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7418, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10591, 32),
      ))
    }

@delegate:ResourceContentHash(-1_895_604_100)
internal val Res.string.skin_dragon: StringResource by lazy {
      StringResource("string:skin_dragon", "skin_dragon", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7447, 27),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7447, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7999, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8171, 27),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9211, 35),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8491, 31),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7447, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10624, 27),
      ))
    }

@delegate:ResourceContentHash(-220_726_347)
internal val Res.string.skin_drake: StringResource by lazy {
      StringResource("string:skin_drake", "skin_drake", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7475, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7475, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8031, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8199, 26),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9247, 34),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8523, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7475, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10652, 26),
      ))
    }

@delegate:ResourceContentHash(-868_925_616)
internal val Res.string.skin_duck: StringResource by lazy {
      StringResource("string:skin_duck", "skin_duck", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7502, 25),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7502, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8058, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8226, 25),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9282, 29),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8550, 25),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7502, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10679, 25),
      ))
    }

@delegate:ResourceContentHash(-1_320_912_974)
internal val Res.string.skin_eagle: StringResource by lazy {
      StringResource("string:skin_eagle", "skin_eagle", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7528, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7528, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8084, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8252, 26),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9312, 26),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8576, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7528, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10705, 26),
      ))
    }

@delegate:ResourceContentHash(-1_861_257_112)
internal val Res.string.skin_elephant: StringResource by lazy {
      StringResource("string:skin_elephant", "skin_elephant", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7555, 29),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7555, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8115, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8279, 37),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9339, 29),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8607, 33),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7555, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10732, 33),
      ))
    }

@delegate:ResourceContentHash(-1_907_658_880)
internal val Res.string.skin_flamingo: StringResource by lazy {
      StringResource("string:skin_flamingo", "skin_flamingo", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7585, 33),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7585, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8149, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8317, 33),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9369, 41),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8641, 37),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7585, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10766, 33),
      ))
    }

@delegate:ResourceContentHash(1_247_493_195)
internal val Res.string.skin_fox: StringResource by lazy {
      StringResource("string:skin_fox", "skin_fox", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7619, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7615, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8183, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8351, 24),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9411, 28),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8679, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7619, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10800, 20),
      ))
    }

@delegate:ResourceContentHash(674_486_414)
internal val Res.string.skin_frog: StringResource by lazy {
      StringResource("string:skin_frog", "skin_frog", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7644, 25),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7640, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8208, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8376, 33),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9440, 29),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8704, 29),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7644, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10821, 25),
      ))
    }

@delegate:ResourceContentHash(224_715_021)
internal val Res.string.skin_giraffe: StringResource by lazy {
      StringResource("string:skin_giraffe", "skin_giraffe", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7670, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7666, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8234, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8410, 28),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9470, 32),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8734, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7670, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10847, 32),
      ))
    }

@delegate:ResourceContentHash(605_448_408)
internal val Res.string.skin_gorilla: StringResource by lazy {
      StringResource("string:skin_gorilla", "skin_gorilla", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7703, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7699, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8263, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8439, 32),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9503, 32),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8763, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7703, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10880, 32),
      ))
    }

@delegate:ResourceContentHash(-2_124_344_143)
internal val Res.string.skin_hamster: StringResource by lazy {
      StringResource("string:skin_hamster", "skin_hamster", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7736, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7732, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8292, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8472, 32),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9536, 40),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8796, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7736, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10913, 32),
      ))
    }

@delegate:ResourceContentHash(-1_017_053_592)
internal val Res.string.skin_hedgehog: StringResource by lazy {
      StringResource("string:skin_hedgehog", "skin_hedgehog", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7765, 29),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7761, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8325, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8505, 33),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9577, 41),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8829, 37),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7765, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10946, 33),
      ))
    }

@delegate:ResourceContentHash(1_359_864_604)
internal val Res.string.skin_hippo: StringResource by lazy {
      StringResource("string:skin_hippo", "skin_hippo", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7795, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7791, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8355, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8539, 34),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9619, 26),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8867, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7795, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10980, 26),
      ))
    }

@delegate:ResourceContentHash(-801_553_585)
internal val Res.string.skin_koala: StringResource by lazy {
      StringResource("string:skin_koala", "skin_koala", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7822, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7818, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8390, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8574, 26),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9646, 30),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8894, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7822, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11007, 26),
      ))
    }

@delegate:ResourceContentHash(1_540_673_393)
internal val Res.string.skin_leopard: StringResource by lazy {
      StringResource("string:skin_leopard", "skin_leopard", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7849, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7849, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8417, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8601, 32),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9677, 32),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8925, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7849, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11034, 32),
      ))
    }

@delegate:ResourceContentHash(41_332_061)
internal val Res.string.skin_lion: StringResource by lazy {
      StringResource("string:skin_lion", "skin_lion", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7878, 25),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7878, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8450, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8634, 25),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9710, 33),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8954, 25),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7878, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11067, 25),
      ))
    }

@delegate:ResourceContentHash(-1_051_291_660)
internal val Res.string.skin_monkey: StringResource by lazy {
      StringResource("string:skin_monkey", "skin_monkey", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7904, 27),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7904, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8476, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8660, 27),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9744, 27),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 8980, 31),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7904, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11093, 27),
      ))
    }

@delegate:ResourceContentHash(173_588_078)
internal val Res.string.skin_octopus: StringResource by lazy {
      StringResource("string:skin_octopus", "skin_octopus", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7932, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7932, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8504, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8688, 32),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9772, 28),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9012, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7932, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11121, 32),
      ))
    }

@delegate:ResourceContentHash(-826_196_957)
internal val Res.string.skin_owl: StringResource by lazy {
      StringResource("string:skin_owl", "skin_owl", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7961, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7961, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8533, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8721, 28),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9801, 32),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9041, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7961, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11154, 20),
      ))
    }

@delegate:ResourceContentHash(71_158_074)
internal val Res.string.skin_panda: StringResource by lazy {
      StringResource("string:skin_panda", "skin_panda", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 7990, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 7990, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8558, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8750, 26),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9834, 30),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9070, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7990, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11175, 26),
      ))
    }

@delegate:ResourceContentHash(-1_600_055_600)
internal val Res.string.skin_parrot: StringResource by lazy {
      StringResource("string:skin_parrot", "skin_parrot", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8017, 27),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8017, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8585, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8777, 31),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9865, 31),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9097, 31),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8017, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11202, 27),
      ))
    }

@delegate:ResourceContentHash(-984_335_729)
internal val Res.string.skin_peacock: StringResource by lazy {
      StringResource("string:skin_peacock", "skin_peacock", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8045, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8045, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8613, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8809, 28),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9897, 36),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9129, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8045, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11230, 32),
      ))
    }

@delegate:ResourceContentHash(1_569_550_015)
internal val Res.string.skin_penguin: StringResource by lazy {
      StringResource("string:skin_penguin", "skin_penguin", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8074, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8074, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8646, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8838, 32),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9934, 36),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9158, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8074, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11263, 32),
      ))
    }

@delegate:ResourceContentHash(1_598_746_915)
internal val Res.string.skin_phoenix: StringResource by lazy {
      StringResource("string:skin_phoenix", "skin_phoenix", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8103, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8103, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8679, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8871, 32),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 9971, 32),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9187, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8103, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11296, 32),
      ))
    }

@delegate:ResourceContentHash(163_479_131)
internal val Res.string.skin_pig: StringResource by lazy {
      StringResource("string:skin_pig", "skin_pig", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8136, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8136, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8708, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8904, 24),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10004, 24),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9220, 24),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8136, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11329, 20),
      ))
    }

@delegate:ResourceContentHash(-1_834_131_343)
internal val Res.string.skin_rhino: StringResource by lazy {
      StringResource("string:skin_rhino", "skin_rhino", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8161, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8161, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8733, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8929, 34),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10029, 26),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9245, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8161, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11350, 26),
      ))
    }

@delegate:ResourceContentHash(927_971_481)
internal val Res.string.skin_sauropod: StringResource by lazy {
      StringResource("string:skin_sauropod", "skin_sauropod", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8188, 29),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8188, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8768, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8964, 29),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10056, 29),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9276, 29),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8188, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11377, 29),
      ))
    }

@delegate:ResourceContentHash(1_341_827_672)
internal val Res.string.skin_shark: StringResource by lazy {
      StringResource("string:skin_shark", "skin_shark", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8218, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8218, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8798, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8994, 26),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10086, 26),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9306, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8218, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11407, 26),
      ))
    }

@delegate:ResourceContentHash(789_827_818)
internal val Res.string.skin_snake: StringResource by lazy {
      StringResource("string:skin_snake", "skin_snake", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8245, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8245, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8829, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9021, 30),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10113, 26),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9333, 22),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8245, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11434, 26),
      ))
    }

@delegate:ResourceContentHash(2_100_072_701)
internal val Res.string.skin_squid: StringResource by lazy {
      StringResource("string:skin_squid", "skin_squid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8272, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8272, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8860, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9052, 26),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10140, 26),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9356, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8272, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11461, 26),
      ))
    }

@delegate:ResourceContentHash(-1_827_585_316)
internal val Res.string.skin_tiger: StringResource by lazy {
      StringResource("string:skin_tiger", "skin_tiger", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8299, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8299, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8891, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9079, 26),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10167, 26),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9387, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8299, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11488, 26),
      ))
    }

@delegate:ResourceContentHash(-753_810_727)
internal val Res.string.skin_trex: StringResource by lazy {
      StringResource("string:skin_trex", "skin_trex", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8326, 25),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8326, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8918, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9106, 25),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10194, 33),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9418, 29),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8326, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11515, 25),
      ))
    }

@delegate:ResourceContentHash(216_205_060)
internal val Res.string.skin_turtle: StringResource by lazy {
      StringResource("string:skin_turtle", "skin_turtle", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8352, 27),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8352, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8944, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9132, 27),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10228, 27),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9448, 31),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8352, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11541, 27),
      ))
    }

@delegate:ResourceContentHash(-619_991_559)
internal val Res.string.skin_unicorn: StringResource by lazy {
      StringResource("string:skin_unicorn", "skin_unicorn", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8380, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8380, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8976, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9160, 32),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10256, 40),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9480, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8380, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11569, 32),
      ))
    }

@delegate:ResourceContentHash(786_641_904)
internal val Res.string.skin_whale: StringResource by lazy {
      StringResource("string:skin_whale", "skin_whale", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8413, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8413, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9009, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9193, 30),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10297, 30),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9513, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8413, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11602, 26),
      ))
    }

@delegate:ResourceContentHash(-1_921_357_186)
internal val Res.string.skin_wolf: StringResource by lazy {
      StringResource("string:skin_wolf", "skin_wolf", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8440, 25),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8440, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9040, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9224, 25),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10328, 33),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9540, 25),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8440, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11629, 25),
      ))
    }

@delegate:ResourceContentHash(-1_243_047_400)
internal val Res.string.skin_zebra: StringResource by lazy {
      StringResource("string:skin_zebra", "skin_zebra", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8466, 26),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8466, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9066, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9250, 26),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10362, 34),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9566, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8466, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11655, 26),
      ))
    }

@delegate:ResourceContentHash(-1_971_552_315)
internal val Res.string.splash_auth_failed: StringResource by lazy {
      StringResource("string:splash_auth_failed", "splash_auth_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8493, 54),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8493, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9093, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9277, 66),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10397, 66),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9597, 66),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8493, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11682, 58),
      ))
    }

@delegate:ResourceContentHash(-1_837_993_279)
internal val Res.string.splash_retry_connection: StringResource by lazy {
      StringResource("string:splash_retry_connection", "splash_retry_connection", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8548, 47),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8548, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9152, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9344, 63),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10464, 43),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9664, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8548, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11741, 55),
      ))
    }

@delegate:ResourceContentHash(-1_754_117_575)
internal val Res.string.splash_subtitle: StringResource by lazy {
      StringResource("string:splash_subtitle", "splash_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8596, 43),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8596, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9212, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9408, 47),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10508, 71),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9716, 63),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8596, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11797, 47),
      ))
    }

@delegate:ResourceContentHash(-628_431_584)
internal val Res.string.stats_best_mass: StringResource by lazy {
      StringResource("string:stats_best_mass", "stats_best_mass", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8640, 39),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8640, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9260, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9456, 35),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10580, 39),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9780, 43),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8640, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11845, 35),
      ))
    }

@delegate:ResourceContentHash(-1_106_634_019)
internal val Res.string.stats_games_played: StringResource by lazy {
      StringResource("string:stats_games_played", "stats_games_played", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 8680, 42),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 8680, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9300, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9492, 46),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10620, 46),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 9824, 50),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8680, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11881, 42),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("privacy_card_desc", Res.string.privacy_card_desc)
  map.put("privacy_card_title", Res.string.privacy_card_title)
  map.put("privacy_hosted_url_hint", Res.string.privacy_hosted_url_hint)
  map.put("privacy_notice_title", Res.string.privacy_notice_title)
  map.put("privacy_open_button", Res.string.privacy_open_button)
  map.put("privacy_operator_callout", Res.string.privacy_operator_callout)
  map.put("safety_block", Res.string.safety_block)
  map.put("safety_blocked_confirm", Res.string.safety_blocked_confirm)
  map.put("safety_close", Res.string.safety_close)
  map.put("safety_reason_cheating", Res.string.safety_reason_cheating)
  map.put("safety_reason_offensive", Res.string.safety_reason_offensive)
  map.put("safety_reason_other", Res.string.safety_reason_other)
  map.put("safety_reason_prompt", Res.string.safety_reason_prompt)
  map.put("safety_report", Res.string.safety_report)
  map.put("safety_report_failed", Res.string.safety_report_failed)
  map.put("safety_reporting", Res.string.safety_reporting)
  map.put("safety_thanks", Res.string.safety_thanks)
  map.put("safety_title", Res.string.safety_title)
  map.put("safety_unblock", Res.string.safety_unblock)
  map.put("settings", Res.string.settings)
  map.put("settings_back_to_menu", Res.string.settings_back_to_menu)
  map.put("settings_controls_title", Res.string.settings_controls_title)
  map.put("settings_controls_title_compact", Res.string.settings_controls_title_compact)
  map.put("settings_ctrl_eject", Res.string.settings_ctrl_eject)
  map.put("settings_ctrl_leave", Res.string.settings_ctrl_leave)
  map.put("settings_ctrl_pause", Res.string.settings_ctrl_pause)
  map.put("settings_ctrl_split", Res.string.settings_ctrl_split)
  map.put("settings_ctrl_steer_joystick", Res.string.settings_ctrl_steer_joystick)
  map.put("settings_ctrl_steer_pointer", Res.string.settings_ctrl_steer_pointer)
  map.put("settings_ctrl_toggle_joystick", Res.string.settings_ctrl_toggle_joystick)
  map.put("settings_ctrl_zoom", Res.string.settings_ctrl_zoom)
  map.put("settings_desc", Res.string.settings_desc)
  map.put("settings_joystick_mode_active", Res.string.settings_joystick_mode_active)
  map.put("settings_joystick_mode_desc", Res.string.settings_joystick_mode_desc)
  map.put("settings_pointer_mode_active", Res.string.settings_pointer_mode_active)
  map.put("settings_pointer_mode_desc", Res.string.settings_pointer_mode_desc)
  map.put("settings_preferences", Res.string.settings_preferences)
  map.put("settings_sound_effects", Res.string.settings_sound_effects)
  map.put("settings_sound_effects_desc", Res.string.settings_sound_effects_desc)
  map.put("settings_subtitle", Res.string.settings_subtitle)
  map.put("settings_title", Res.string.settings_title)
  map.put("settings_use_joystick", Res.string.settings_use_joystick)
  map.put("settings_use_joystick_desc", Res.string.settings_use_joystick_desc)
  map.put("settings_version", Res.string.settings_version)
  map.put("single_player", Res.string.single_player)
  map.put("single_player_desc", Res.string.single_player_desc)
  map.put("skin_bat", Res.string.skin_bat)
  map.put("skin_bear", Res.string.skin_bear)
  map.put("skin_bee", Res.string.skin_bee)
  map.put("skin_bunny", Res.string.skin_bunny)
  map.put("skin_butterfly", Res.string.skin_butterfly)
  map.put("skin_cat", Res.string.skin_cat)
  map.put("skin_chick", Res.string.skin_chick)
  map.put("skin_cow", Res.string.skin_cow)
  map.put("skin_crab", Res.string.skin_crab)
  map.put("skin_crocodile", Res.string.skin_crocodile)
  map.put("skin_dog", Res.string.skin_dog)
  map.put("skin_dolphin", Res.string.skin_dolphin)
  map.put("skin_dragon", Res.string.skin_dragon)
  map.put("skin_drake", Res.string.skin_drake)
  map.put("skin_duck", Res.string.skin_duck)
  map.put("skin_eagle", Res.string.skin_eagle)
  map.put("skin_elephant", Res.string.skin_elephant)
  map.put("skin_flamingo", Res.string.skin_flamingo)
  map.put("skin_fox", Res.string.skin_fox)
  map.put("skin_frog", Res.string.skin_frog)
  map.put("skin_giraffe", Res.string.skin_giraffe)
  map.put("skin_gorilla", Res.string.skin_gorilla)
  map.put("skin_hamster", Res.string.skin_hamster)
  map.put("skin_hedgehog", Res.string.skin_hedgehog)
  map.put("skin_hippo", Res.string.skin_hippo)
  map.put("skin_koala", Res.string.skin_koala)
  map.put("skin_leopard", Res.string.skin_leopard)
  map.put("skin_lion", Res.string.skin_lion)
  map.put("skin_monkey", Res.string.skin_monkey)
  map.put("skin_octopus", Res.string.skin_octopus)
  map.put("skin_owl", Res.string.skin_owl)
  map.put("skin_panda", Res.string.skin_panda)
  map.put("skin_parrot", Res.string.skin_parrot)
  map.put("skin_peacock", Res.string.skin_peacock)
  map.put("skin_penguin", Res.string.skin_penguin)
  map.put("skin_phoenix", Res.string.skin_phoenix)
  map.put("skin_pig", Res.string.skin_pig)
  map.put("skin_rhino", Res.string.skin_rhino)
  map.put("skin_sauropod", Res.string.skin_sauropod)
  map.put("skin_shark", Res.string.skin_shark)
  map.put("skin_snake", Res.string.skin_snake)
  map.put("skin_squid", Res.string.skin_squid)
  map.put("skin_tiger", Res.string.skin_tiger)
  map.put("skin_trex", Res.string.skin_trex)
  map.put("skin_turtle", Res.string.skin_turtle)
  map.put("skin_unicorn", Res.string.skin_unicorn)
  map.put("skin_whale", Res.string.skin_whale)
  map.put("skin_wolf", Res.string.skin_wolf)
  map.put("skin_zebra", Res.string.skin_zebra)
  map.put("splash_auth_failed", Res.string.splash_auth_failed)
  map.put("splash_retry_connection", Res.string.splash_retry_connection)
  map.put("splash_subtitle", Res.string.splash_subtitle)
  map.put("stats_best_mass", Res.string.stats_best_mass)
  map.put("stats_games_played", Res.string.stats_games_played)
}
